class AppOrderRecord {
  constructor(data, config) {
    this.option4ExcessRoyalty = data.option_4_excess_royalty
    this.option1ExcessRoyalty = data.option_1_excess_royalty
    this.sourceUrl = data.source_url
    this.source = data.source
    this.applicant = data.applicant
    this.option3ExcessRoyalty = data.option_3_excess_royalty
    this.completedCost = data.completed_cost
    this.orderNumber = data.order_number
    this.state = data.state
    this.formation = data.formation
    this.option3Bonus = data.option_3_bonus
    this.option1Bonus = data.option_1_bonus
    this.meridian = data.meridian
    this.unitSize = data.unit_size
    this.township = data.township
    this.option2Bonus = data.option_2_bonus
    this.section = data.section
    this.appOrOrder = data.app_or_order
    this.county = data.county
    this.option5Bonus = data.option_5_bonus
    this.legal = data.legal
    this.option2ExcessRoyalty = data.option_2_excess_royalty
    this.vaultDataId = data.vaultDataId
    this.quarterCall = data.quarter_call
    this.scanDate = data.scan_date
    this.orderDate = data.order_date
    this.range = data.range
    this.status = data.status
    this.causeNumber = data.cause_number
    this.surfaceLocation = data.surface_location
    this.configuration = data.configuration
    this.dryHoleCost = data.dry_hole_cost
    this.typeOfDocument = data.type_of_document
    this.option4Bonus = data.option_4_bonus
    this.option5ExcessRoyalty = data.option_5_excess_royalty
    this.vacate = data.vacate
    this.addedAt = data.added_at
    this.appDate = data.app_date
    this.attachmentUrl = config.appOrderAttachmentEndpoint + data.cause_number
  }
}

export default AppOrderRecord
